import { useState } from "react"
import DatatableComponent from "../../../../../components/common/DatatableComponent/DatatableComponent"
import EditUserRoleModal from "./EditUserRoleModal/EditUserRoleModal"
import YellowHeaderWrapper from "../../../../../components/common/YellowHeaderWrapper/YellowHeaderWrapper"

const ManageUsers = () => {
  const [isModalOpen, setIsModalOpen] = useState(false)

  const data = [
    { user: "Economy", email: "Loremipsum@gmail.com", roles: "Administrator", lastLogin: "1 hour ago" },
    { user: "Standard", email: "Loremipsum@gmail.com", roles: "Inventory Manager", lastLogin: "2 hours ago" },
    { user: "Express", email: "Loremipsum@gmail.com", roles: "Order Processor", lastLogin: "Yesterday" },
    { user: "In-Store Pickup", email: "Loremipsum@gmail.com", roles: "Customer Service", lastLogin: "05/07/2024" },
    { user: "Same-day delivery", email: "Loremipsum@gmail.com", roles: "Marketing Manager", lastLogin: "05/07/2024" },
  ]

  const columns = [
    { name: "Users", selector: (row) => row.user },
    { name: "Emails", selector: (row) => row.email },
    { name: "Roles", selector: (row) => row.roles },
    { name: "Last Login", selector: (row) => row.lastLogin },
    {
      name: "Action",
      cell: () => (
        <div className="d-flex gap-2">
          <span className="cursor-pointer" onClick={() => setIsModalOpen(true)}>
            Edit
          </span>{" "}
          <span className="cursor-pointer">Delete</span>
        </div>
      ),
    },
  ]

  return (
    <div>
      <YellowHeaderWrapper title={"Manage Users"}>
        <DatatableComponent data={data} columns={columns} type={"gray"} />
      </YellowHeaderWrapper>

      <EditUserRoleModal isModalOpen={isModalOpen} setIsModalOpen={setIsModalOpen} />
    </div>
  )
}

export default ManageUsers
